import { IframeExt } from '@distribute/shared/tiptap/extensions';

export const Iframe = IframeExt;
